import React from "react";
export default function IngenOpgaver() {
  return <div>Der er ingen ejendomme på denne fejlliste</div>;
}
